var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartAdd = function SvgCartAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.979 10.396c0-.95-.562-1.766-1.366-2.153l1.328-3.98-1.515-.506L13.009 8H5.42L3.017.021H.021v1.596H1.83l2.404 7.979h9.35c.438 0 .8.357.8.8 0 .438-.358.8-.8.8H3.212v1.595h.945c-.09.252-.15.515-.15.8a2.4 2.4 0 0 0 2.396 2.396A2.4 2.4 0 0 0 8.8 13.592c0-.281-.06-.55-.149-.8h1.094c-.09.25-.149.514-.149.8a2.4 2.4 0 0 0 2.396 2.395 2.4 2.4 0 0 0 2.395-2.395c0-.315-.063-.613-.174-.89 1.013-.285 1.766-1.204 1.766-2.306m-8.775 3.191c0 .438-.357.8-.8.8a.8.8 0 0 1-.8-.8c0-.438.358-.8.8-.8.439 0 .8.358.8.8m4.788.796a.8.8 0 0 1-.8-.8c0-.438.357-.8.8-.8.438 0 .8.357.8.8a.805.805 0 0 1-.8.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10 0H8.5v2h-2v1.5h2v2H10v-2h2V2h-2z",
    clipRule: "evenodd"
  })));
};
export default SvgCartAdd;